// extracted by mini-css-extract-plugin
var _1 = "IconsCourse_large__b4809";
var _2 = "IconsCourse_medium__d3cd3";
var _3 = "IconsCourse_mini__bd90c";
var _4 = "IconsCourse_root__06078";
var _5 = "IconsCourse_xmini__b0134";
export { _1 as "large", _2 as "medium", _3 as "mini", _4 as "root", _5 as "xmini" }
